angular.module('bribac.components.reportModal', [,
    'bribac.values',
    'bribac.entities.kinds',
    'bribac.services.api',
    'bribac.validators.requiredWithTrim',
    'bribac.translations',
  ])

    .component('reportModal', {
      templateUrl: 'report-modal-component.html',
      controller: 'ReportModalComponentCtrl',
      bindings: {
        close: '&',
        dismiss: '&',
        modalInstance: '<',
        resolve: '<'
      }
    })

    .controller('ReportModalComponentCtrl', function(
      $translate,
      $scope,
      $filter,
      saveBlobAsFile,
      api
    ) {
        var $ctrl = this

        $ctrl.includeOptionalSamples = true

        $ctrl.toggleDatePicker = function (picker) {
            $ctrl.datePickerOpen[picker] = !$ctrl.datePickerOpen[picker]
        }

        $scope.$watch('$ctrl.report.startDate', function (newVal) {
            $ctrl.reportOptions.endDate.minDate = newVal
        })

        $scope.$watch('$ctrl.report.endDate', function (newVal) {
            $ctrl.reportOptions.startDate.maxDate = newVal
        })

        $ctrl.reportOptions = {
            startDate: {initDate: null},
            endDate: {}
        }

        $ctrl.datePickerOpen = {
            startDate: false,
            endDate: false
        }


        $ctrl.$onInit = function () {
            $ctrl.subject = $ctrl.resolve.data
            $ctrl.report = {
                subject: $ctrl.subject
            }
            $ctrl.reportType =  $ctrl.resolve.apiMethod
            $ctrl.extensionToExport = $ctrl.resolve.extension.value
            $ctrl.showIncludeOptionalSamples = $ctrl.resolve.showIncludeOptionalSamples !== null ? $ctrl.resolve.showIncludeOptionalSamples : true
        }

        $ctrl.sendReport = function () {
            var $form = $ctrl.reportForm
            if ($form._submitting) return
            if ($form.$invalid) {
                $form._submitError = 'formErrors.invalidFields'
                return
            }

            $form._submitSuccess = ''
            $form._submitError = ''
            $form._submitting = true

            var parameters = angular.copy($ctrl.report);
            var isoStringMillisecondsRegex = /\.\d{3}/
            parameters.startDate = $ctrl.report.startDate.toISOString().replace(isoStringMillisecondsRegex, '')
            parameters.endDate = $ctrl.report.endDate.toISOString().replace(isoStringMillisecondsRegex, '')
            parameters.includeOptionalSamples = $ctrl.includeOptionalSamples
            api.report($ctrl.reportType.apiMethod, parameters)
                .finally(function () {
                    $form._submitting = false
                })
                .then(
                    function success(request) {
                        var blob = new Blob([request.data], {type: request.headers()['content-type']})
                        var fileName = ''
                        if ($ctrl.subject) {
                            fileName += $ctrl.subject.fullName + ' - '
                        }

                        const extensionToExport = $ctrl.extensionToExport || '.xls'
                        fileName += $ctrl.reportType.apiMethod +
                            ' - ' + $filter('date')($ctrl.report.startDate, "yyyy-MM-dd") +
                            ' - ' + $filter('date')($ctrl.report.endDate, "yyyy-MM-dd") +
                            extensionToExport
                        saveBlobAsFile(blob, fileName)
                        resetForm($form)
                    },
                    function error(request) {
                        $form._submitError = request.statusText
                    }
                )
        }

        function resetForm($form) {
            if ($form) {
                $form.$setUntouched()
                $form.$setPristine()
            }
        }
    })